<template>
  <div id="loading" class="custom-loader">
    <img class="display-dark" src="/img/HXWhite.png" alt="logo_loader" />
    <img class="display-light" src="/img/HXWblack.png" alt="logo_loader" />
    <!-- <img src="../../assets/images/login/01.png" alt="logo_loader" /> -->
  </div>
</template>
<script>
import { animation } from "@/config/pluginInit";
export default {
  name: "Loader",
  watch: {
    $route: function () {
      this.init();
    },
  },
  computed: {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const load = document.getElementById("loading");

      if (this.$route.meta.sinLoader) {
        load.classList.add("d-none");
        return; // Si la ruta tiene sinLoader en meta, no mostrar el loader
      }
      load.classList.remove("d-none");
      window.scrollTo({ top: 0, behavior: "smooth" });
      animation.fadeIn(load, { duration: 20 });
      setTimeout(() => {
        animation.fadeOut(load, { duration: 20 });
        load.classList.add("d-none");
      }, 1000);
    },
  },
};
</script>

<style scoped>
.custom-loader {
  display: grid;
  place-items: center;
  /* background: url(../../assets/images/fondo_nuevo_dashboard2.jpg); */
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  background-color: rgba(255, 255, 255, 0.25) !important;
}
.dark .custom-loader {
  display: grid;
  place-items: center;
  /* background: url(../../assets/images/fondo_nuevo_dashboard2.jpg); */
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  background-color: #1a1a1a40 !important;
}
.custom-loader img {
  width: 100px;
  animation: bellShake 1.5s infinite;
}

@keyframes bellShake {
  0% {
    opacity: 0;
    transform: scale(0.9);
  }
  20% {
    opacity: 1;
    transform: scale(1.1) rotate(-5deg);
  }
  40% {
    transform: scale(1) rotate(5deg);
  }
  60% {
    transform: scale(1.1) rotate(-3deg);
  }
  80% {
    transform: scale(1) rotate(0deg);
  }
  100% {
    opacity: 0;
    transform: scale(1.5);
  }
}
</style>
